import React from 'react';
import { Tooltip } from '../../../../UiKit';
import { WFHCall } from '../../../commons';
import { OrdersForSomeoneElse } from '../../../tooltip';
import { Repeat } from 'sushiweb/Icons';
import { viewText } from '../../../../images/images';
import { grey } from 'sushiweb/tokens/color';
import { OFSEUserCallClickEvent } from '../../../../analytics/call-logging/events';
import { useSelector } from 'react-redux';

export const OFSEDetails = ({
  number = 'XXXXXXXXXX',
  user = null,
  ofseInfo = null,
  isWFH = false,
  calledTo,
  orderId = null,
  userId = null,
  isNewUser = false,
  unmaskNumber = () => {},
  regenerateNumber = () => {},
  cartId = null,
}) => {
  const isNewUI = useSelector((state) => state.ordersState?.isNewUI);

  return (
    <div>
      <Tooltip
        position='bottom'
        title={
          <div className='ofse'>
            Call on &nbsp;
            {ofseInfo ? (
              <span data-dd-privacy='mask'>{ofseInfo.number}</span>
            ) : (
              <div className='masked' data-dd-privacy='mask'>
                {number}
              </div>
            )}
            {isWFH ? (
              <WFHCall
                orderId={orderId}
                userId={userId}
                isNewUser={isNewUser}
                pos='top'
                isOfse={true}
                isUser={true}
                calledTo={calledTo}
                sendJumboEvent={true}
                jumboEventFunc={OFSEUserCallClickEvent}
                JumboEventProperties={{
                  is_new_ui: isNewUI,
                }}
                cartId={cartId}
              />
            ) : null}
          </div>
        }
        label={() => <OrdersForSomeoneElse user={user.ofse_data} />}
      />
      {!ofseInfo && (
        <span
          className='pointer icon iconMarginL'
          onClick={() => unmaskNumber(false)}
        >
          <img src={viewText} alt='' />
        </span>
      )}
      {ofseInfo && (
        <Tooltip
          position='bottom'
          border={false}
          title={
            <div
              className='pointer'
              onClick={() =>
                regenerateNumber(ofseInfo.masked_number_popup, true)
              }
            >
              <Repeat size={18} color={grey.z500} />
            </div>
          }
          label='Renew Masked Number'
        />
      )}
    </div>
  );
};
